// extracted by mini-css-extract-plugin
module.exports = {"Image":"BriefImageStyles1_Image__ho6if"};